import axios from "axios";
import Cookies from "js-cookie";
import { MODE } from "../utility/constants";

const logged_token = Cookies.get("LoggedUser");
const instance = axios.create({
  baseURL:
    MODE == "DEV"
      ? "http://localhost:3030/api/"
      : "https://admin.alhamroorhazard.com/api/",
  timeout: 60000,
  withCredentials: true,
  headers: { Authorization: `Bearer ${logged_token}` },
});
export default instance;
